function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
import { Text, StyleSheet, View, TouchableOpacity } from "react-native";
import Loader from "../../../components/src/Loader";
import SocialMediaAccountWebController, { configJSON } from "../../social-media-account/src/SocialMediaAccountWebController";
import CustomFacebookLogInButton from "../../social-media-account/src/CustomFacebookLogInButton";
import CustomGoogleLogInButton from "../../social-media-account/src/CustomGoogleLogInButton";
class SocialMediaAccountRegistrationScreen extends SocialMediaAccountWebController {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      isRegistration: true
    };
  }
  render() {
    const {
      loading
    } = this.state;
    return /*#__PURE__*/React.createElement(View, {
      style: styles.container
    }, /*#__PURE__*/React.createElement(Loader, {
      loading: loading
    }), /*#__PURE__*/React.createElement(Text, {
      style: styles.labelTitle //UI Engine::From Sketch
    }, configJSON.signUpTitleText, " "), /*#__PURE__*/React.createElement(Text, {
      style: styles.titleWhySignUp //UI Engine::From Sketch
    }, configJSON.signUpBodyText, " "), /*#__PURE__*/React.createElement(CustomFacebookLogInButton, _extends({
      testID: "btnFacebookLogIn" //Merge Engine::From BDS
      ,
      appId: "170982444234877" //Merge Engine::From SDS
      ,
      loginFacebookButtonText: configJSON.facebookButtonText //UI Engine::From Sketch
    }, this.btnFacebookLogInProps)), /*#__PURE__*/React.createElement(CustomGoogleLogInButton, _extends({
      testID: "btnGoogleLogIn" //Merge Engine::From BDS
      ,
      style: styles.googleStyle //UI Engine::From Sketch
      ,
      loginGoogleButtonText: configJSON.googleButtonText //UI Engine::From Sketch
      ,
      googleButtonImageStyle: styles.googleButtonImageStyle //UI Engine::From Sketch
      ,
      googleButtonTextStyle: styles.googleButtonTextStyle //UI Engine::From Sketch
    }, this.btnGoogleLogInProps)), /*#__PURE__*/React.createElement(Text, {
      style: styles.orTextStyle //UI Engine::From Sketch
    }, "or "), /*#__PURE__*/React.createElement(View, {
      style: styles.logInButtonContainer //UI Engine::From Sketch
    }, /*#__PURE__*/React.createElement(TouchableOpacity, _extends({
      testID: "btnNavigate" //Merge Engine::From BDS
      ,
      style: styles.signUpButtonStyle //UI Engine::From Sketch
    }, this.btnNavigateProps), /*#__PURE__*/React.createElement(Text, {
      style: styles.signUpButtonTextStyle //UI Engine::From Sketch
    }, configJSON.signUpButtonText, " "))));
  }
}
const styles = StyleSheet.create({
  container: {
    flex: 1,
    // justifyContent: "center",
    alignItems: "center",
    backgroundColor: "#F5FCFF"
  },
  logInButtonContainer: {
    overflow: "hidden",
    display: undefined,
    flexDirection: "row",
    flexWrap: "wrap",
    justifyContent: "center",
    alignContent: "flex-start",
    alignItems: "center",
    shadowColor: "black",
    shadowOpacity: 0.3,
    shadowRadius: 8,
    height: 40,
    width: 205,
    marginTop: 16,
    elevation: 6,
    backgroundColor: "#ffffff"
  },
  facebookStyle: {
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "center",
    shadowColor: "black",
    shadowOpacity: 0.3,
    elevation: 6,
    shadowRadius: 8,
    borderWidth: 0,
    borderRadius: 0,
    backgroundColor: "#ffffff",
    padding: "11px"
  },
  facebookImageStyle: {
    marginRight: 10,
    width: 20,
    height: 20
  },
  facebookTextStyle: {
    color: "#2553b4",
    fontFamily: "Helvetica-Bold, sans-serif",
    paddingLeft: 7
  },
  googleStyle: {
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "center",
    shadowColor: "black",
    shadowOpacity: 0.3,
    elevation: 6,
    shadowRadius: 8,
    borderWidth: 0,
    borderRadius: 0,
    backgroundColor: "#ffffff",
    padding: "11px",
    marginTop: 32
  },
  googleButtonImageStyle: {
    marginRight: 15,
    width: 20,
    height: 20
  },
  googleButtonTextStyle: {
    paddingLeft: 6,
    paddingRight: 3,
    fontSize: 14,
    color: "#2553b4",
    fontFamily: "Helvetica-Bold, sans-serif",
    marginLeft: 8
  },
  orTextStyle: {
    color: "#00000",
    fontWeight: "bold",
    alignSelf: "center",
    margin: 20
  },
  signUpButtonStyle: {
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "center",
    shadowColor: "black",
    shadowOpacity: 0.3,
    elevation: 6,
    shadowRadius: 8,
    borderWidth: 0,
    borderRadius: 0,
    backgroundColor: "#ffffff",
    padding: "11px",
    height: "100%",
    width: "100%"
  },
  signUpButtonTextStyle: {
    color: "#2553b4",
    fontSize: 11,
    fontFamily: "Helvetica-Bold, sans-serif"
  },
  titleWhySignUp: {
    marginBottom: 32,
    fontSize: 16,
    textAlign: "left",
    marginVertical: 8
  },
  labelTitle: {
    marginTop: 24,
    marginBottom: 32,
    fontSize: 32,
    textAlign: "left",
    marginVertical: 8,
    color: "#6200EE"
  }
});
export default SocialMediaAccountRegistrationScreen;